import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ModelSelectionPage from '../../pages/ModelSelectionPage/ModelSelectionPage';
import SignIn from './SignIn';
import PrivateRoute from './PrivateRoute';
import PostActionPage from '../../pages/PostActionPage/PostActionPage';
import AvailableClassPage from '../../pages/AvailableClassPage/AvailableClassPage';
import MergeRuleDetailPage from '../../pages/PostActionPage/subroutes/detail/MergeRuleDetailPage';
import ConvertPage from '../../pages/PostActionPage/subroutes/convert/ConvertPage';
import ThresholdPage from '../../pages/PostActionPage/subroutes/threshold/ThresholdPage';
import ServicePage from '../../pages/PostActionPage/subroutes/service/ServicePage';
import EvaluationPage from '../../pages/PostActionPage/subroutes/evaluation/EvaluationPage';
import LiveTestPage from '../../pages/PostActionPage/subroutes/live-test/LiveTestPage';
import LoadExistingMergeRuleDetail from '../../pages/PostActionPage/components/LoadExistingMergeRuleDetail';
import MainPage from '../../pages/MainPage/MainPage';
import ExperimentsPage from '../../pages/ExperimentsPage/ExperimentsPage';
import DBGeneratoinPage from '../../pages/DBGenerationPage/DBGeneratoinPage';
import DBGenarationDetail from '../../pages/DBGenerationPage/DBGenarationDetail';
import DBTrainingProgressPage from '../../pages/TrainingProgressPage/DBTrainingProgressPage';
import ModelTrainingProgressPage from '../../pages/TrainingProgressPage/ModelTrainingProgressPage';
import { useEffect, useState } from 'react';
import ExperimentDetail from '../../pages/ExperimentsPage/ExperimentDetail';
import TrainingComparisonPage from '../../pages/ExperimentsPage/TrainingComparisonPage';
import TrainingReportPage from '../../pages/TrainingReportPage/TrainingReportPage';
import EvaluationComparisonPage from '../../pages/EvaluationComparisonPage/EvaluationComparisonPage';
import ServiceArchivePage from '../../pages/ServiceArchivePage/ServiceArchivePage';
import CustomSoundPage from '../../pages/CustomSoundPage/CustomSoundPage';
import CustomSoundDetail from '../../pages/CustomSoundPage/CustomSoundDetail';

const DefaultRouter = () => {
    const [authenticated, setAuthenticated] = useState(localStorage.getItem('expiredAt') !== null);

    useEffect(() => {
        const expiredAt = localStorage.getItem('expiredAt')
        // verify if there is exp in localstorage
        if (expiredAt) {
            setAuthenticated(false)
            // verify if the expiration date doesn't exceed
            const expirationDate = new Date(expiredAt);
            const currentDate = new Date();
            if (currentDate < expirationDate) {
                setAuthenticated(true)
            }
        }
    }, [])
    return (
        <Router>
            <div className='bg-gray-100 h-full w-full min-h-screen items-center'>
                <Routes>
                    {/* TODO: need to change the main page later */}
                    <Route path='/' element={
                        <PrivateRoute
                            authenticated={authenticated}
                            component={<MainPage />}
                        />} />
                    <Route path='/signin' element={<SignIn setAuthenticated={setAuthenticated} />} />
                    {/* for db gneration */}
                    <Route path='/db-generation' element={
                        <PrivateRoute
                            authenticated={authenticated}
                            component={<DBGeneratoinPage />}
                        />} />
                    <Route path='/db-generation/detail/:id' element={
                        <PrivateRoute
                            authenticated={authenticated}
                            component={<DBGenarationDetail />}
                        />} />
                    <Route path='/training-progress/dbs/:id' element={
                        <PrivateRoute
                            authenticated={authenticated}
                            component={<DBTrainingProgressPage />}
                        />} />
                    <Route path='/training-progress/models/:modelName' element={
                        <PrivateRoute
                            authenticated={authenticated}
                            component={<ModelTrainingProgressPage />}
                        />} />
                    {/* for training part */}
                    <Route path='/experiments' element={
                        <PrivateRoute
                            authenticated={authenticated}
                            component={<ExperimentsPage />}
                        />} />
                    <Route path='/experiments/:id' element={
                        <PrivateRoute
                            authenticated={authenticated}
                            component={<ExperimentDetail />}
                        />} />
                    <Route path='/experiments/:id/comparison' element={
                        <PrivateRoute
                            authenticated={authenticated}
                            component={<TrainingComparisonPage />}
                        />} />
                    {/* for post action part */}
                    <Route path='/model-selection' element={
                        <PrivateRoute
                            authenticated={authenticated}
                            component={<ModelSelectionPage />}
                        />} />
                    <Route path='/post-action/models/:generalModelId' element={
                        <PrivateRoute
                            authenticated={authenticated}
                            component={<PostActionPage />}
                        />}>
                        <Route path='/post-action/models/:generalModelId/merge-rules/:mergeRuleId/detail' element={
                            <PrivateRoute
                                authenticated={authenticated}
                                component={<MergeRuleDetailPage />}
                            />} />
                        <Route path='/post-action/models/:generalModelId/merge-rules/:mergeRuleId/convert' element={
                            <PrivateRoute
                                authenticated={authenticated}
                                component={<ConvertPage />}
                            />} />
                        <Route path='/post-action/models/:generalModelId/merge-rules/:mergeRuleId/thresholds' element={
                            <PrivateRoute
                                authenticated={authenticated}
                                component={<ThresholdPage />}
                            />} />
                        <Route path='/post-action/models/:generalModelId/merge-rules/:mergeRuleId/evaluations' element={
                            <PrivateRoute
                                authenticated={authenticated}
                                component={<EvaluationPage />}
                            />} />
                        <Route path='/post-action/models/:generalModelId/merge-rules/:mergeRuleId/services' element={
                            <PrivateRoute
                                authenticated={authenticated}
                                component={<ServicePage />}
                            />} />
                        <Route path='/post-action/models/:generalModelId/merge-rules/:mergeRuleId/live-test' element={
                            <PrivateRoute
                                authenticated={authenticated}
                                component={<LiveTestPage />}
                            />} />
                    </Route>
                    <Route path='/all-classes/:generalModelName' element={
                        <PrivateRoute
                            authenticated={authenticated}
                            component={<AvailableClassPage />}
                        />} />
                    <Route path='/training-report/:id' element={
                        <PrivateRoute
                            authenticated={authenticated}
                            component={<TrainingReportPage />}
                        />} />
                    <Route path='/merge-rule/:id' element={
                        <PrivateRoute
                            authenticated={authenticated}
                            component={<LoadExistingMergeRuleDetail />}
                        />} />
                    {/* for evaluation comparison */}
                    <Route path='/evaluation-comparison' element={
                        <PrivateRoute
                            authenticated={authenticated}
                            component={<EvaluationComparisonPage />}
                        />} />
                    {/* for service archive page */}
                    <Route path='/service-archive' element={
                        <PrivateRoute
                            authenticated={authenticated}
                            component={<ServiceArchivePage />}
                        />} />
                    {/* for custom sound page */}
                    <Route path='/custom-sound' element={
                        <PrivateRoute
                            authenticated={authenticated}
                            component={<CustomSoundPage />}
                        />} />
                    <Route path='/custom-sound/detail/:id' element={
                        <PrivateRoute
                            authenticated={authenticated}
                            component={<CustomSoundDetail />}
                        />} />
                </Routes>
            </div>
        </Router>
    )
}

export default DefaultRouter;